
import {
  GET_PAYFAC_COMMISSIONS_BY_PRICING_TABLE_GUID_AND_MERCHANT_GUID,
  GET_PAYFAC_COMMISSIONS_BY_PRICING_TABLE_GUID_AND_MERCHANT_GUID_SUCCESS,
  INSERT_MERCHANT_COMMISSIONS,
  INSERT_MERCHANT_COMMISSIONS_SUCCESS,
  UPDATE_MERCHANT_COMMISSIONS,
  UPDATE_MERCHANT_COMMISSIONS_SUCCESS,
  MERCHANT_COMMISSION_LIST_API_ERROR
} from "./actionTypes"

const INIT_STATE = {
  recordList: [],
  error: {},
}


const merchantCommissionList = (state = INIT_STATE, action) => {
  switch (action.type) {

    case GET_PAYFAC_COMMISSIONS_BY_PRICING_TABLE_GUID_AND_MERCHANT_GUID:
      return {
        ...state,
        loading: true,
        recordList: state.recordList,
      }

    case GET_PAYFAC_COMMISSIONS_BY_PRICING_TABLE_GUID_AND_MERCHANT_GUID_SUCCESS:
      return {
        ...state,
        loading: false,
        recordList: action.payload,
      }

    case INSERT_MERCHANT_COMMISSIONS:
      return {
        ...state,
        loading: true,
        recordList: state.recordList,
      }

    case INSERT_MERCHANT_COMMISSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        recordList: action.payload,
      }

    case UPDATE_MERCHANT_COMMISSIONS:
      return {
        ...state,
        loading: true,
        recordList: state.recordList,
      }

    case UPDATE_MERCHANT_COMMISSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        recordList: action.payload,
      }

    case MERCHANT_COMMISSION_LIST_API_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    default:

      return state

  }
}

export default merchantCommissionList